import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { ref, computed } from 'vue'

  // Config
  import { ModalId } from '@/config/modalIds'

  // Components
  import PageSection from '@/components/UI/PageSection.vue'
  import AccordionItem from './AccordionItem.vue'
  import SlidingPanel from '@/components/UI/SlidingPanel.vue'
  import EditInfoForm from '@/components/Profile/EditInfoForm/EditInfoForm.vue'
  import EditPasswordForm from '@/components/Profile/EditPasswordForm/EditPasswordForm.vue'
  import CommunicationPreferencesForm from '@/components/Profile/CommunicationPreferencesForm.vue'
  import { isCdaOptInEnabledForUser } from '@/logic/contact/isCdaOptInEnabled'

  // Store
  import { useStore } from '@/store'

  // Translations
  import { useI18n } from 'vue-i18n'

  // Service
  import CSEService from '@/services/CSEService'

  enum PanelType {
    INFO = 'info',
    COMMUNICATION = 'communication',
    PASSWORD = 'password',
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'SettingsSection',
  setup(__props) {

  const { t } = useI18n()

  // Enum for Panel Types
  const store = useStore()

  const showCdaOptIn = computed(() =>
    isCdaOptInEnabledForUser(store.state.auth?.user?.iresa_id)
  )

  // Visibility state
  const isPanelVisible = computed(() => {
    const checkIsOpen = store.getters['modal/isOpen']
    return checkIsOpen(ModalId.EDIT_INFO_PANEL)
  })

  // Tracks which panel to show
  const currentPanel = ref<PanelType | null>(null)

  // Methods
  const handleOpenPanel = (panel: PanelType): void => {
    currentPanel.value = panel
    store.commit('modal/open', ModalId.EDIT_INFO_PANEL)
  }

  const handleClosePanel = (): void => {
    currentPanel.value = null
    store.commit('modal/close', ModalId.EDIT_INFO_PANEL)
  }

  const isEditable = computed<boolean>(() => {
    const cseService = new CSEService()
    return !cseService.isCgosOrCGOSPM
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageSection, {
    title: _unref(t)('profile.settingsTitle')
  }, {
    default: _withCtx(() => [
      _createVNode(AccordionItem, {
        text: _unref(t)('profile.myInfo'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (handleOpenPanel(PanelType.INFO)))
      }, null, 8, ["text"]),
      _createVNode(AccordionItem, {
        text: _unref(t)('profile.resetPassword'),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (handleOpenPanel(PanelType.PASSWORD)))
      }, null, 8, ["text"]),
      (showCdaOptIn.value)
        ? (_openBlock(), _createBlock(AccordionItem, {
            key: 0,
            text: _unref(t)('profile.communicationPreferences.menuItem'),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (handleOpenPanel(PanelType.COMMUNICATION)))
          }, null, 8, ["text"]))
        : _createCommentVNode("", true),
      _createVNode(SlidingPanel, {
        isPanelVisible: isPanelVisible.value,
        onClose: handleClosePanel
      }, {
        default: _withCtx(() => [
          (currentPanel.value === PanelType.INFO)
            ? (_openBlock(), _createBlock(EditInfoForm, {
                key: 0,
                editable: isEditable.value
              }, null, 8, ["editable"]))
            : (currentPanel.value === PanelType.COMMUNICATION)
              ? (_openBlock(), _createBlock(CommunicationPreferencesForm, {
                  key: 1,
                  onClose: handleClosePanel
                }))
              : (currentPanel.value === PanelType.PASSWORD)
                ? (_openBlock(), _createBlock(EditPasswordForm, { key: 2 }))
                : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["isPanelVisible"])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})